import { render } from "./ModalReceipt.vue?vue&type=template&id=08f8fe0e&scoped=true&ts=true"
import script from "./ModalReceipt.vue?vue&type=script&lang=ts"
export * from "./ModalReceipt.vue?vue&type=script&lang=ts"

import "./ModalReceipt.vue?vue&type=style&index=0&id=08f8fe0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f8fe0e"]])

export default __exports__